import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
var _excluded = ["todayButtonText", "showCalendar", "icon", "containerClassName", "labelId", "openWithIconOnly", "testId", "id", "name", "minDate", "maxDate", "className", "calendarClassName", "popperClassName", "disabled", "startOpen", "onCalendarOpen", "onCalendarClose", "validationMessages", "isValid", "registerValidation", "hideTodayButton", "customInputProps", "renderCustomHeader", "inputFormat", "showMask", "noMask", "showMonthYearPicker"];
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import cx from "classnames";
import defaultLocaleObject from "date-fns/locale/en-US";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import DatePicker, { registerLocale } from "react-datepicker";
import { isTodayOutOfRange, LocaleContext, useTranslator } from "@jutro/locale";
import { uniqueInnerId } from "@jutro/platform";
import { getValidationMessageStyle } from "@jutro/validation/internal";
import { Button } from "../../../button/Button";
import { CustomInput } from "./CustomInput";
import { NextButton, PrevButton } from "./Header";
import { PopperContainer } from "./PopperContainer";
import { messages as datePickerMessages } from "../DateField/DateField.messages";
import { messages } from "./GenericDatePicker.messages";
import inputStyles from "../../InputField/InputField.module.css";
import styles from "./GenericDatePicker.module.css";
var renderPopperContainer = function (calendarId, labelId) {
    return function (props) {
      return React.createElement(PopperContainer, _extends({}, props, {
        labelId: labelId,
        calendarId: calendarId
      }));
    };
  },
  renderDayContents = function (day) {
    return React.createElement("span", {
      className: styles.dayContent
    }, day, React.createElement("span", {
      className: styles.todayIndicator
    }));
  };
export var GenericDatePicker = React.forwardRef(function (props, ref) {
  var _cx2,
    _context,
    todayButtonText = props.todayButtonText,
    showCalendar = props.showCalendar,
    icon = props.icon,
    labelId = (props.containerClassName, props.labelId),
    openWithIconOnly = props.openWithIconOnly,
    testId = props.testId,
    id = props.id,
    name = props.name,
    minDate = props.minDate,
    maxDate = props.maxDate,
    className = props.className,
    calendarClassName = props.calendarClassName,
    popperClassName = props.popperClassName,
    disabled = props.disabled,
    startOpen = props.startOpen,
    _onCalendarOpen = props.onCalendarOpen,
    _onCalendarClose = props.onCalendarClose,
    validationMessages = props.validationMessages,
    isValid = props.isValid,
    registerValidation = props.registerValidation,
    hideTodayButton = props.hideTodayButton,
    customInputProps = props.customInputProps,
    renderCustomHeaderFn = props.renderCustomHeader,
    inputFormat = props.inputFormat,
    showMask = props.showMask,
    noMask = props.noMask,
    showMonthYearPicker = props.showMonthYearPicker,
    datePickerProps = _objectWithoutProperties(props, _excluded),
    translator = useTranslator(),
    dateLocale = useContext(LocaleContext).dateLocale;
  useEffect(function () {
    registerLocale(dateLocale.code || "en-US", isEmpty(dateLocale) ? defaultLocaleObject : dateLocale);
  }, [dateLocale]);
  var _useState = useState(startOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1],
    calendarId = uniqueInnerId(null != id ? id : "", "calendarId").calendarId,
    datePickerAutoComplete = name ? "on" : "off",
    todayOutOfRange = isTodayOutOfRange({
      minDateObject: minDate,
      maxDateObject: maxDate
    }),
    popperClasses = cx(_defineProperty({}, styles.hidePopper, !showCalendar)),
    focusCalendar = useCallback(function (event) {
      event.preventDefault();
      var selectedNode = null == ref ? void 0 : ref.current.calendar.componentNode.querySelector('[tabindex="0"]');
      selectedNode && selectedNode.focus({
        preventScroll: !0
      });
    }, [ref]),
    handleKeyDown = useCallback(function (event) {
      var target = event.target;
      showCalendar && isOpen && "Tab" === event.key && target.id === id && focusCalendar(event);
    }, [isOpen, id, showCalendar, focusCalendar]),
    messageStyle = useMemo(function () {
      return getValidationMessageStyle(validationMessages);
    }, [validationMessages]),
    inputClasses = cx((_defineProperty(_cx2 = {
      disabled: disabled
    }, inputStyles.labpreviewBorder, !isUndefined(registerValidation) && !isValid), _defineProperty(_cx2, messageStyle, !isValid), _cx2), className),
    renderCustomHeader = renderCustomHeaderFn && function (headerProps) {
      return renderCustomHeaderFn(_objectSpread(_objectSpread({}, headerProps), {}, {
        PrevButtonComponent: PrevButton,
        NextButtonComponent: NextButton
      }));
    },
    _flat = _flatInstanceProperty(_context = [inputFormat]).call(_context),
    firstDateFormat = _slicedToArray(_flat, 1)[0],
    normalisedAndTranslatedDateFormat = useMemo(function () {
      return firstDateFormat && ensureTwoCharsForDaysAndMonth(firstDateFormat).replace("dd", translator(datePickerMessages.dd)).replace("MM", translator(datePickerMessages.mm)).replace("yyyy", translator(datePickerMessages.yy));
    }, [firstDateFormat, translator]);
  return React.createElement("div", {
    className: styles.datePicker,
    "aria-expanded": !!isOpen,
    "aria-haspopup": "true",
    "aria-controls": calendarId,
    role: "combobox"
  }, React.createElement(DatePicker, _extends({
    ref: ref,
    onKeyDown: handleKeyDown,
    autoComplete: datePickerAutoComplete,
    todayButton: !hideTodayButton && React.createElement(Button, {
      className: styles.todayButton,
      disabled: todayOutOfRange,
      type: "text"
    }, translator(todayButtonText || messages.today)),
    popperContainer: renderPopperContainer(calendarId, labelId),
    id: id,
    name: name,
    open: isOpen,
    minDate: minDate,
    maxDate: maxDate,
    disabled: disabled,
    customInput: React.createElement(CustomInput, _extends({
      noMask: noMask,
      showMask: firstDateFormat && showMask,
      mask: normalisedAndTranslatedDateFormat,
      icon: icon,
      showCalendar: showCalendar,
      openWithIconOnly: openWithIconOnly,
      focusCalendar: focusCalendar,
      "data-testid": testId || id,
      disabled: disabled
    }, customInputProps)),
    dateFormat: showMask && firstDateFormat ? ensureTwoCharsForDaysAndMonth(firstDateFormat) : firstDateFormat
  }, datePickerProps, {
    onCalendarOpen: function () {
      setOpen(!0), null == _onCalendarOpen || _onCalendarOpen();
    },
    onCalendarClose: function () {
      setOpen(!1), null == _onCalendarClose || _onCalendarClose();
    },
    className: inputClasses,
    calendarClassName: cx(calendarClassName, _defineProperty({}, styles.monthYearPicker, showMonthYearPicker)),
    popperClassName: cx(popperClasses, popperClassName),
    renderCustomHeader: renderCustomHeader,
    renderDayContents: renderDayContents,
    showMonthYearPicker: showMonthYearPicker
  })));
});
function ensureTwoCharsForDaysAndMonth(mask) {
  var _context2,
    lookFor = ["d", "D", "m", "M"],
    charsCounter = _reduceInstanceProperty(lookFor).call(lookFor, function (map, currentChar) {
      return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, currentChar, 0));
    }, {});
  return mask.split("").forEach(function (char) {
    _includesInstanceProperty(lookFor).call(lookFor, char) && (charsCounter[char] += 1);
  }), _reduceInstanceProperty(_context2 = _filterInstanceProperty(lookFor).call(lookFor, function (letter) {
    return 1 === charsCounter[letter];
  })).call(_context2, function (newMask, letter) {
    var _context3;
    return newMask.replace(letter, _concatInstanceProperty(_context3 = "".concat(letter)).call(_context3, letter));
  }, mask);
}
GenericDatePicker.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "GenericDatePicker"
}, renderDayContents.__docgenInfo = {
  componentName: "renderDayContents",
  packageName: "@jutro/components",
  description: "",
  displayName: "renderDayContents",
  methods: [],
  actualName: "renderDayContents"
};